import type { NextPage } from 'next'

import { PageLayout } from 'src/libs/layout'
import {
    Header,
    Heading2,
    Heading3,
    Paragraph,
    TextSection,
    ImageWithCaption,
} from 'src/libs/page-blog'

import image1UseSFLike2021 from './assets/3-things-improve/1-use-sf-like-2021.png'
import image2CloseDate from './assets/3-things-improve/2-close-dates.png'
import image3QuarterPounderField from './assets/3-things-improve/3-quarter-pounder-field.gif'
import image4MouseClick from './assets/3-things-improve/4-mouse-click.gif'
import image5BenioffMemoji from './assets/3-things-improve/5-benioff-memoji.png'

const SalesforceThreeThingsImprove: NextPage = () => {
    return (
        <PageLayout>
            <Header
                title="The 3 things that Salesforce needs to improve for Salespeople"
                metadata={{
                    duration: 2,
                    date: new Date(2021, 9, 16),
                }}
                image={{
                    src: image1UseSFLike2021,
                    alt: 'Laserfocus.io use Salesforce like it’s 2021.',
                }}
            />
            <TextSection>
                <Paragraph>Guess what? It’s 2021, and people are still using Salesforce.</Paragraph>
                <Paragraph>
                    Because you know: If it’s not in Salesforce it doesn’t exist. 🥱
                </Paragraph>
                <Paragraph>
                    But we were still wondering why so many people still complain about it, so we
                    talked with hundreds of Salesforce users and found out that they all have the
                    same problems:
                </Paragraph>

                <Heading2>1. Messy interface (it’s 2021 not 1999)</Heading2>
                <Paragraph>
                    Salesforce was built for the enterprises that didn’t know better. It’s an
                    amazing database but not really what you call intuitive. You wouldn’t endure
                    such an interface for your personal apps, right?
                </Paragraph>
                <ImageWithCaption
                    src={image2CloseDate}
                    caption="Close dates in 1900, anyone?"
                    alt="Salesforce proposing close date in 1900"
                />
                <Heading2>2. Hello, have you seen the field I’m looking for?</Heading2>
                <Paragraph>
                    Everyone puts new fields into Salesforce until you end up with the unedited
                    version of War and Peace. Wouldn’t it be really nice to see only what you want
                    to see and cut all the noise?
                </Paragraph>
                <ImageWithCaption
                    src={image3QuarterPounderField}
                    caption="Where can I find the Quarter Pounder field?"
                    alt="John Travolta looking for a field in Salesforce"
                />
                <Heading3>3. How many Clicks does it takes?</Heading3>
                <Paragraph>
                    Click, Click, Click, Click, etc. So many unnecessary steps involved to do one
                    small thing. Almost like carpal tunnel syndrome doctors have a secret pact with
                    SF.
                </Paragraph>
                <ImageWithCaption
                    src={image4MouseClick}
                    alt="Hand clicking the mouse"
                    caption="Legend has that some people are still clicking to log an activity."
                />
                <Heading3>Conclusion</Heading3>
                <Paragraph>
                    Well, this is the bluntest blog post ever to say that our software Laserfocus
                    would solve the mentioned problems.
                </Paragraph>
                <Paragraph>We can’t even be more obvious besides having Marc B. saying:</Paragraph>
                <Paragraph>
                    “You should try Laserfocus, when you want to step up your Salesforce game!”
                </Paragraph>
                <ImageWithCaption
                    src={image5BenioffMemoji}
                    layout="fixed"
                    width={234}
                    height={(234 * image5BenioffMemoji.height) / image5BenioffMemoji.width}
                    alt="Marc Binioff giving thumbs up"
                    caption="“You should try Laserfocus, when you want to step up your Salesforce game!” - Marc B."
                    className="mb-0"
                />
            </TextSection>
        </PageLayout>
    )
}

export default SalesforceThreeThingsImprove
